import { render, staticRenderFns } from "./WhereIsMyAccuralsTinkoff.vue?vue&type=template&id=600fdae7"
import script from "./WhereIsMyAccuralsTinkoff.vue?vue&type=script&lang=js"
export * from "./WhereIsMyAccuralsTinkoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports